import { createFileRoute, notFound } from "@tanstack/react-router";
import liveStyles from "../styles/live.css?url";
import { LiveList } from "../components/live/live-list";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadLives } from "../server/live";

/** Lives (/streams): what's on, what's coming and replays. Private and never cached. */
export const Route = createFileRoute("/streams/")({
  loader: async () => {
    const data = await loadLives();
    if (!data) throw notFound();
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head = creatorPageHead(shell, {
      pathname: "/streams",
      title: `Live | ${shell.creator.name}`,
      description: `Live streams from ${shell.creator.name} for members.`,
      noindex: true,
    });
    return withStylesheet(head, liveStyles);
  },
  component: Lives,
});

function Lives() {
  return <LiveList data={Route.useLoaderData()} />;
}
